var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloudBlueMediumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6375 15.8966C29.5608 10.4341 24.7633 6.33325 19 6.33325C14.4242 6.33325 10.45 8.92992 8.47083 12.7299C3.705 13.2366 0 17.2741 0 22.1666C0 27.4074 4.25917 31.6666 9.5 31.6666H30.0833C34.4533 31.6666 38 28.1199 38 23.7499C38 19.5699 34.7542 16.1816 30.6375 15.8966ZM30.0833 28.4999H9.5C6.00083 28.4999 3.16667 25.6658 3.16667 22.1666C3.16667 18.9208 5.58917 16.2133 8.80333 15.8808L10.4975 15.7066L11.2892 14.2024C12.7933 11.3049 15.7383 9.49992 19 9.49992C23.1483 9.49992 26.7267 12.4449 27.5342 16.5141L28.0092 18.8891L30.4317 19.0633C32.9017 19.2216 34.8333 21.2958 34.8333 23.7499C34.8333 26.3624 32.6958 28.4999 30.0833 28.4999ZM12.6667 20.5833H16.7042V25.3333H21.2958V20.5833H25.3333L19 14.2499L12.6667 20.5833Z",
    fill: "#1F6BEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudBlueMediumIcon);
export default __webpack_public_path__ + "static/media/UploadCloudBlueMediumIcon.8afa1635.svg";
export { ForwardRef as ReactComponent };